import { databases } from "@/lib/appwrite";
import { sendTravelToN8n } from "@/requests/travels/webhook/sendTravelToN8n";
import { ID } from "appwrite";
import { getUserWithProfile } from "../../workerProfile-Users/getUserWithProfile";

const DATABASE_ID = import.meta.env.VITE_APPWRITE_DATABASE_ID;
const TRAVELS_COLLECTION_ID = import.meta.env.VITE_TRAVELS_REQUESTS_COLLECTION_ID;

export type TravelRequestData = {
    userId: string;
    usersId: string[];
    title: string;
    tripPurpose: string;
    startDate: string; // ISO string 
    endDate: string; // ISO string
    status: "pending" | "approved" | "rejected";
    address?: string;
    isInternational: boolean;
    transportationType?: string;
    estimatedCost?: number[];
    companies: string[];
    clients: string[];
    statusByRrhh: "pending" | "approved" | "rejected";
    idApprovedByRrhh?: string | null;
    isGroup: boolean;
    provinces: string[];
    countries: string[];
};

export async function createTravelRequest(
    travelData: TravelRequestData,
    userName: string,
    userEmail: string,
    destination: string
) {
    try {
        // 1. Crear el registro de Travel Request
        const travelRequest = await databases.createDocument(
            DATABASE_ID,
            TRAVELS_COLLECTION_ID,
            ID.unique(),
            {
                userId: travelData.userId,
                usersId: travelData.usersId,
                title: travelData.title,
                tripPurpose: travelData.tripPurpose,
                startDate: travelData.startDate,
                endDate: travelData.endDate,
                status: travelData.status,
                address: travelData.address || null,
                isInternational: travelData.isInternational,
                transportationType: travelData.transportationType || null,
                estimatedCost: travelData.estimatedCost || [],
                companies: travelData.companies,
                clients: travelData.clients,
                statusByRrhh: travelData.statusByRrhh,
                idApprovedByRrhh: travelData.idApprovedByRrhh || null,
                isGroup: travelData.isGroup,
                // Lógica para evitar inconsistencias
                provinces: travelData.isInternational ? [] : travelData.provinces,
                countries: travelData.isInternational ? travelData.countries : [],
            }
        );

        //  Enviar webhook a n8n 
        try {
            const collaboratorsCount = travelData.isGroup
                ? travelData.usersId.length - 1  // Excluye al usuario principal
                : 0;

            const userProfile = await getUserWithProfile(travelData.userId);
            const supervisorId = userProfile?.profile?.idSupervisor;
            const supervisorProfile = supervisorId
                ? await getUserWithProfile(supervisorId)
                : null;
            const supervisorEmail = supervisorProfile?.email;

            await sendTravelToN8n(
                travelRequest.$id,
                travelData.title,
                travelData.startDate,
                travelData.endDate,
                travelData.tripPurpose,
                userName,
                userEmail,
                travelData.isInternational,
                destination,
                travelData.transportationType,
                travelData.estimatedCost?.reduce((a, b) => a + b, 0),
                travelData.address,
                travelData.isGroup,
                collaboratorsCount,
                supervisorEmail
            );
        } catch (webhookError) {
            console.warn('Error enviando webhook (registro guardado):', webhookError);
            // No lanzamos error para que no afecte el flujo principal
        }

        return {
            success: true,
            data: travelRequest,
        };
    } catch (error) {
        console.error("Error creating travel request:", error);
        throw error;
    }
}